export default __webpack_public_path__ + "static/media/IMG_4543-min.a7a50e83.JPG";